<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <span>Zamień z:</span>
        <span>
          {{ productToReplace.name }}
        </span>
        <span v-if="!replacingFromShoppingList()">{{ productToReplace.portion.amount }}</span>
        <span v-if="!replacingFromShoppingList() && productToReplace.portion.weight.amount !== 1"> x</span>
        <span v-if="!replacingFromShoppingList()"> {{ productToReplace.portion.weight.unit }} - </span>
        <span v-if="!replacingFromShoppingList() && !isProductReplacementWithoutEnergy()">{{
            productToReplace.energyInPortion.amount | round(2)
          }} Kcal</span>
        <span v-if="!replacingFromShoppingList() && isProductReplacementWithoutEnergy()">{{
            productToReplace.getTotalWeight().amount
          }} gram</span>
      </v-flex>
    </v-layout>
    <v-divider class="mt-2 mb-2"></v-divider>
    <v-layout row wrap>
      <v-flex xs12>
        <span>Zamień na:</span>
        <span> {{ productReplacement.name }}</span>
        <v-radio-group v-model="selectedWeight">
          <v-radio
              v-for="weight in productReplacement.weight"
              :key="weight.unit"
              :value="weight"
              :label="getAvailableWeightLabel(weight)"
              :color="`success`"
          ></v-radio>
        </v-radio-group>
        <v-checkbox
            :color="`success`"
            v-model="shouldRoundHalf"
            :label="`Zaokrąglij jednostki wagowe do 0.5`"
        >

        </v-checkbox>
      </v-flex>
    </v-layout>
    <v-divider class="mt-2 mb-2"></v-divider>
    <v-layout row wrap v-if="plan">
      <v-flex xs12>
        <span>Dodatkowo zamień i przelicz</span>
        <v-checkbox v-if="false"
                    :color="`success`"
                    v-model="replaceInPlans"
                    :label="`we wszystkich posiłkach ${plan.name}`"
        ></v-checkbox>
        <v-checkbox
            :color="`success`"
            v-model="replaceInMenu"
            :label="`w całym jadłospisie`"
        ></v-checkbox>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style scoped>
div.v-radio.theme--light > label {
  font-size: 14px;
}

.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0;
}

div.v-input__slot > label {
  font-size: 14px;
}

.v-messages {
  min-height: 0;
  height: 0;
}

.v-input--selection-controls {
  margin-top: 5px;
}
</style>
<script>

import {round} from "../../utils/money";
import {productFactory} from "../../factory/product.factory";
import {Portion} from "../../model/portion.model";
import {multiPortionFoodsManager} from "../../services/MultiPortionFoodsManager";
import {mapGetters, mapMutations, mapState} from "vuex";
import uuid from "uuid4";

export default {
  props: {
    plan: {
      type: Object,
      required: false,
      default: null,
    },
    food: {
      type: Object,
      required: false,
      default: null,
    },
    productToReplace: Object,
    productReplacement: Object,
  },
  data() {
    return {
      selectedWeight: null,
      replaceInPlans: false,
      replaceInMenu: false,
      shouldRoundHalf: false,
    }
  },
  created() {
    this.selectedWeight = this.productReplacement.weight[0];
    if (this.plan === null) {
      this.replaceInMenu = true;
    }

    this.resetProductReplacements();
    this.resetFoodsWithReplacements();
    this.replaceInMenu = this.replacingFromShoppingList();
  },
  computed: {
    ...mapState({
      schema: state => state.menu.schema,
    }),
    ...mapGetters([
      'configuration'
    ]),
  },
  methods: {
    ...mapMutations([
      'resetProductReplacements',
      'addProductReplacement',
      'resetFoodsWithReplacements',
      'addFoodWithReplacements',
      'setProductsReplaced',
      'checkFoodRepetition',
    ]),
    getAvailableWeightLabel(weight) {
      if (this.replacingFromShoppingList()) {
        return this.getAvailableWeightLabelForShoppingList(weight);
      }

      if (this.isProductReplacementWithoutEnergy()) {
        return this.getAvailableWeightLabelForProductReplacementWithOutEnergy(weight);
      } else {
        return this.getAvailableWeightLabelForProductReplacementWithEnergy(weight);
      }
    },

    getAvailableWeightLabelForShoppingList(weight) {
      return `${weight.unit}`;
    },

    getAvailableWeightLabelForProductReplacementWithOutEnergy(weight) {
      const portionAmount = this.calculatePortionAmountUsingWeight(
          this.productToReplace.getTotalWeight().amount,
          weight.amount
      );

      let label = `${portionAmount}`;
      if (weight.amount !== 1) {
        label = `${label} x`;
      }

      label = `${label} ${weight.unit}`;
      if (weight.unit !== 'gram') {
        label = `${label} - ${this.calculateWeightForPortion(
            weight.amount,
            portionAmount
        )} - gram`;
      }

      return label;
    },

    getAvailableWeightLabelForProductReplacementWithEnergy(weight) {
      const portionAmount = this.calculatePortionAmountUsingEnergy(
          this.productToReplace.energyInPortion.amount,
          this.productReplacement.energy.amount,
          weight.amount
      );

      let label = `${portionAmount}`;
      if (weight.amount !== 1) {
        label = `${label} x`;
      }

      return `${label} ${weight.unit} - ${this.calculateEnergyForPortion(
          this.productReplacement.energy.amount,
          portionAmount,
          weight.amount
      )} Kcal`;
    },

    calculatePortionAmountUsingEnergy(requiredEnergy, newProductEnergy, newProductWeightAmount) {
      let portionAmount = 0.01;

      if (requiredEnergy > 0) {
        portionAmount = 100 * requiredEnergy / newProductEnergy / newProductWeightAmount;
      }

      if (portionAmount >= 0.05 && portionAmount <= 0.09) {
        portionAmount = round(portionAmount, 1);
      } else {
        portionAmount = round(portionAmount, 2);
      }

      if (this.shouldRoundHalf) {
        return this.halfRound(portionAmount);
      }

      return portionAmount < 0.01 ? 0.01 : portionAmount;
    },

    calculatePortionAmountUsingWeight(requiredWeight, weightAmount) {
      let portionAmount = requiredWeight / weightAmount;
      if (this.shouldRoundHalf) {
        return this.halfRound(portionAmount);
      }

      return round(portionAmount, 2);
    },

    halfRound(portionAmount) {
      portionAmount = round(round(portionAmount * 2, 0) / 2, 1)
      return portionAmount < 0.5 ? 0.5 : portionAmount;
    },

    calculateEnergyForPortion(newProductEnergy, portionAmount, portionWeightAmount) {
      round(newProductEnergy * portionAmount * portionWeightAmount / 100, 2);
      return round(newProductEnergy * portionAmount * portionWeightAmount / 100, 2);
    },

    calculateWeightForPortion(productWeight, portionAmount) {
      return round(productWeight * portionAmount, 2);
    },

    replaceProduct() {
      if (this.replaceInMenu) {
        this.replaceProductInMenu(this.productToReplace);
        this.emitEvent('menu');
        return;
      }

      if (this.replaceInPlans) {
        this.replaceProductInPlans(this.productToReplace);
        this.emitEvent('plans');
        return;
      }

      if (this.food === null) {
        this.replaceProductInPlan(this.plan, this.productToReplace, false);
        this.emitEvent('plan');
      } else {
        this.replaceProductInFood(this.food, this.productToReplace);
        this.emitEvent('food');
      }
    },

    emitEvent(mode) {
      this.$root.$emit('products-replaced', mode);
      this.setProductsReplaced(true);
    },

    replaceProductInFood(food, productToReplace) {
      const productReplacement = this.makeProductReplacement(productToReplace);

      this.checkFoodRepetition(food);
      food.replaceProduct(productToReplace.id, productReplacement);
      this.checkFoodRepetition(food);
      if (food.isMultiPortionFood()) {
        multiPortionFoodsManager.updateMultiPortionFood(food, this.schema);
      }

      this.addFoodWithReplacements(food);
    },

    replaceProductInPlans(productToReplace) {
      this.schema.days.forEach(day => {
        day.plans.forEach(plan => {
          if (this.plan.name === plan.name) {
            this.replaceAllProductsInPlan(plan, productToReplace);
          }
        });
      });
    },

    replaceProductInPlan(plan, productToReplace, addProductReplacement = true) {
      if (this.replaceInMenu) {
        plan.findProductsBy(productToReplace.externalId, 'externalId')
            .forEach((planProductToReplace) => {
              const productReplacement = this.makeProductReplacement(planProductToReplace);
              plan.replaceProduct(planProductToReplace.id, productReplacement);
              if (addProductReplacement) {
                this.addProductReplacement(productReplacement);
              }
        });
      } else {
        const planProductToReplace = plan.findProduct(productToReplace.externalId, 'externalId');
        const productReplacement = this.makeProductReplacement(planProductToReplace);
        plan.replaceProduct(planProductToReplace.id, productReplacement);
        if (addProductReplacement) {
          this.addProductReplacement(productReplacement);
        }
      }
    },

    replaceAllProductsInPlan(plan, productToReplace) {
      this.replaceProductInPlan(plan, productToReplace);

      plan.foods.forEach(food => {
        if (this.replaceInMenu) {
          food.findProductsBy(productToReplace.externalId, 'externalId')
              .forEach((foodProductToReplace) => {
                this.replaceProductInFood(food, foodProductToReplace);
          });
        } else {
          let foodProductToReplace = food.findProduct(productToReplace.externalId, 'externalId');
          this.replaceProductInFood(food, foodProductToReplace);
        }
      })
    },

    replaceProductInMenu(productToReplace) {
      this.schema.days.forEach(day => {
        day.plans.forEach(plan => {
          this.replaceAllProductsInPlan(plan, productToReplace);
        })
      });
    },

    makeProductReplacement(productToReplace) {
      let amount;

      if (this.isProductReplacementWithoutEnergy()) {
        amount = this.calculatePortionAmountUsingWeight(
            productToReplace.getTotalWeight().amount,
            this.selectedWeight.amount
        )
      } else {
        amount = this.calculatePortionAmountUsingEnergy(
            productToReplace.energyInPortion.amount,
            this.productReplacement.energy.amount,
            this.selectedWeight.amount
        );
      }

      return productFactory.create(
          uuid(),
          this.productReplacement.externalId,
          this.productReplacement.name,
          this.productReplacement.weight,
          this.productReplacement.energy.amount,
          this.productReplacement.category,
          this.productReplacement.allergen,
          this.productReplacement.disliked,
          this.productReplacement.nutrients,
          new Portion(amount, this.selectedWeight)
      )
    },

    replacingFromShoppingList() {
      return this.plan === null;
    },

    isProductReplacementWithoutEnergy() {
      return this.productReplacement.energy.amount === 0;
    },
  }
}
</script>
